import { render, staticRenderFns } from "./teamMember.vue?vue&type=template&id=4da0e3da&scoped=true&"
import script from "./teamMember.vue?vue&type=script&lang=js&"
export * from "./teamMember.vue?vue&type=script&lang=js&"
import style0 from "./teamMember.vue?vue&type=style&index=0&id=4da0e3da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4da0e3da",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4da0e3da')) {
      api.createRecord('4da0e3da', component.options)
    } else {
      api.reload('4da0e3da', component.options)
    }
    module.hot.accept("./teamMember.vue?vue&type=template&id=4da0e3da&scoped=true&", function () {
      api.rerender('4da0e3da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2GZ57B9oWzZAL/JS/teamMember.vue"
export default component.exports